import React from "react";

export const LoadingState = ({ label = "Loading workflow operations data..." }) => (
  <div className="workflow-ops-alert">{label}</div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div className="workflow-ops-alert error">
    <div>{message || "Unable to load workflow operations data."}</div>
    {onRetry ? (
      <button type="button" className="btn btn-link p-0 mt-2" onClick={onRetry}>
        Retry
      </button>
    ) : null}
  </div>
);

export const EmptyState = ({ message = "No rows match the current filter." }) => (
  <div className="workflow-ops-alert">{message}</div>
);

export const DeniedState = ({ reason }) => (
  <div className="workflow-ops-alert error">
    {reason || "Trading Workbench is currently unavailable for this account."}
  </div>
);
